<template>
    <div class="container">
        <video class="full" muted autoplay loop src="http://localhost:81/3680.mp4"></video>
        <iframe class="full" src="/#/home" frameborder="0" style="border: none;"></iframe>
        <div class="screen1"><img class="qr" :src="qr1"></div>
        <div class="screen2"><img class="qr" :src="qr2"></div>
        <div class="screen3"><img class="qr" :src="qr3"></div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    data() {
        return {
            qr1: require('./image/qr-1.png'),
            qr2: require('./image/qr-2.png'),
            qr3: require('./image/qr-3.png'),
        }
    },
    mounted() {
    },
}
</script>

<style scoped>
.container {
    width: 100%;
    height: 100vh;
    display: flex;
}
.full {
    position: absolute;
    width: 100%;
    height: 100vh;
}
.screen1, .screen2, .screen3 {
    width: 33.3333%;
    height: 100%;
    position: relative;
}
.qr {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 9.75%;
    height: 9%;
    object-fit: fill;
}
</style>
